import { ConfirmDialogIdentifier } from 'legacy/lut/components/shared/Confirm/actions'
import { useConfirm } from 'legacy/lut/components/shared/Confirm/useConfirm'
import { ConfirmationDialog as ConfirmationDialogContent } from 'legacy/lut/components/widgets/public/partner360/programsManagementAdmin/ConfirmationDialog'
import React, { useEffect } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import styles from './ConfirmationDialog.module.scss'

type Props = {
  identifier: ConfirmDialogIdentifier

  text: string
  submitText?: string
  submitColor?: 'primary' | 'success' | 'warning' | 'danger' | 'white' | 'grey'
  cancelText?: string
  cancelButtonClassName?: string
  translation?: boolean
  isCommitmentSigned?: boolean
  replaceParams?: {
    key: string
    value: string
  }[]
  htmlAvailable?: boolean
  withoutCancelSection?: boolean
}

export function ConfirmationDialog(props: Props) {
  const { identifier, ...confirmDialogProps } = props
  const { confirmState, onConfirm, onCancel, registerConfirmDialog, unregisterConfirmDialog } =
    useConfirm()

  const handleConfirm = () => {
    onConfirm(identifier)
  }

  const handleCancel = () => {
    onCancel(identifier)
  }

  useEffect(() => {
    registerConfirmDialog(identifier)
    return () => {
      unregisterConfirmDialog(identifier)
    }
  }, [])

  return (
    <ModalDialog
      closeOnOutsideClick={false}
      classes={{
        overlay: styles.hideCrossIcon,
      }}
      show={!!confirmState[identifier]}
      content={ConfirmationDialogContent}
      size="xs"
      onClose={handleCancel}
      contentProps={{
        ...confirmDialogProps,
        onClick: (result: boolean) => {
          if (result) {
            handleConfirm()
          } else {
            handleCancel()
          }
        },
      }}
    />
  )
}
